module.exports = __webpack_public_path__ + "img/cjrz.56e177d8.png";